import { render, staticRenderFns } from "./ResponseCard.vue?vue&type=template&id=fac2b14c"
import script from "./ResponseCard.vue?vue&type=script&lang=js"
export * from "./ResponseCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports